var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAgregar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "15px",
    viewBox: "0 0 17 15",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "C2017722-CAB2-40AC-99FE-9E841AFB4F31")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Modelos-Originais",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "original",
    transform: "translate(-329.000000, -741.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(0.000000, 721.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.922218,30.2001319 C335.302249,30.2001319 336.420986,31.274619 336.420986,32.6000659 C336.420986,33.9255129 335.302249,35 333.922218,35 C332.542186,35 331.423449,33.9255129 331.423449,32.6000659 C331.423449,31.274619 332.542186,30.2001319 333.922218,30.2001319 Z M333.558779,25.7425084 C337.53512,25.7425084 340.758581,29.0987189 340.758581,33.2388144 C340.758581,33.9288303 340.221338,34.4881988 339.558614,34.4881988 C338.895891,34.4881988 338.358647,33.9288303 338.358647,33.2388144 C338.358647,30.4787507 336.209673,28.2412771 333.558779,28.2412771 C332.666232,28.2412771 331.8123,28.4941378 331.067858,28.9658503 C330.501732,29.3245735 329.763496,29.1375405 329.418961,28.5481004 C329.074427,27.9586603 329.254062,27.190022 329.820188,26.8312989 C330.937968,26.1230222 332.222995,25.7425084 333.558779,25.7425084 Z M333.664126,20.7282048 C340.291361,20.7282048 345.663797,26.321889 345.663797,33.2220482 C345.663797,33.9120641 345.126553,34.4714325 344.46383,34.4714325 C343.801106,34.4714325 343.263863,33.9120641 343.263863,33.2220482 C343.263863,27.7019209 338.965914,23.2269735 333.664126,23.2269735 C332.710513,23.2269735 331.776852,23.3713797 330.883482,23.6523589 C330.249072,23.8518912 329.579426,23.4781732 329.387786,22.8176364 C329.196145,22.1570997 329.555082,21.4598759 330.189492,21.2603436 C331.307312,20.9087711 332.474767,20.7282048 333.664126,20.7282048 Z",
    id: "Combined-Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAgregar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/agregar.d7874457.svg";
export { ForwardRef as ReactComponent };